import { createServerFn } from "@tanstack/react-start";
import {
    type CommunicationPreferences,
    CommunicationPreferencesUpdateSchema,
    ProfileSituationSchema,
} from "./viewer-profile.contract";
import {
    getCommunicationPreferencesData,
    getProfileSituationData,
    updateCommunicationPreferencesData,
} from "./profile-settings.server";

export const getCommunicationPreferences = createServerFn({
    method: "GET",
}).handler(() => getCommunicationPreferencesData());

export const getProfileSituation = createServerFn({ method: "GET" }).handler(
    async () => ProfileSituationSchema.parse(await getProfileSituationData()),
);

export const updateCommunicationPreferences = createServerFn({ method: "POST" })
    .inputValidator(
        (input: Pick<CommunicationPreferences, "allowMarketingEmails">) =>
            CommunicationPreferencesUpdateSchema.parse(input),
    )
    .handler(({ data }) =>
        updateCommunicationPreferencesData(data.allowMarketingEmails),
    );
